import { createLogger } from 'lib/logger'
import { createInMemoryStore } from 'lib/stores'
import aServer from './aServer'

const logger = createLogger('oidc', 'color: cyan')

const state = createInMemoryStore({
  enabled: false,
  loginUrl: null,
  loaded: false,
})

let fetchPromise = null

export async function loadOidcConfig() {
  if (state.get().loaded) return state.get()
  if (fetchPromise) return fetchPromise
  fetchPromise = (async () => {
    try {
      const config = await aServer.getJSON('/oidc/config')
      logger.info('OIDC config loaded', config)
      state.set({ ...config, loaded: true })
    } catch (error) {
      logger.error('Failed to load OIDC config', error)
      state.set({ enabled: false, loginUrl: null, loaded: true })
    }
    return state.get()
  })()
  return fetchPromise
}

export function useOidcConfig() {
  const { enabled, loginUrl, loaded } = state.useStore(['enabled', 'loginUrl', 'loaded'])
  if (!loaded) loadOidcConfig()
  return { enabled, loginUrl }
}

// Load on init
loadOidcConfig()
